import { Progress, Stack, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'

type ImportProgressBarProps = {
  total: number
  imported: number
}

export const ImportProgressBar = ({
  total,
  imported
}: ImportProgressBarProps) => {
  const progress = (imported / total) * 100

  return (
    <Stack gap="xs">
      <Progress value={progress} />

      <Text ta="right" size="xs">
        <FormattedMessage
          id="cameras.import.status.count"
          values={{
            count: imported,
            total
          }}
        />
      </Text>
    </Stack>
  )
}
